/*
 * @Author: caiqin.xie
 * @since: 2023-11-09 14:50:23
 * @lastTime: 2023-11-09 15:06:57
 * @LastEditors: caiqin.xie
 * @message: 下载分类常量
 */
// OS
export const OSTYPE = '1696060420490088448';
// Streaming
export const STREAMINGTYPE = '1696061549265375232';
// Remote Play
export const REMOTEPLAYTYPE = '1696061616902721536';
// Cast
export const CASTTYPE = '1696061668844982272';